import { ChatbotAPI } from '../ChatbotAPI';

export function createStubChatbotAPI(): ChatbotAPI {
    return {
        sendMessage: () => null,
        sendLineMessage: () => null,
        sendInstagramMessage: () => null,
        sendTelegramMessage: () => null,
        sendMessengerMessage: () => null,
        validateSubscription: () => null,
        unsubscribe: () => null,

        setAppleDeviceToken: () => null,
        getAppleDeviceTokenUpdatedAt: () => 0,
        appleDeviceTokenIsValid: () => false,

        setAndroidDeviceToken: () => null,
        getAndroidDeviceTokenUpdatedAt: () => 0,
        androidDeviceTokenIsValid: () => false,

        linkRichMenuToUser: () => undefined,
        unlinkRichMenuFromUser: () => undefined,

        setEmail: () => null,
        setWebPushSubscription: () => null,
        subscribeSms: () => null,
        unsubscribeSms: () => null,
    };
}
